export interface Translations {
  // Header
  by: string;
  
  // Player
  noChapterSelected: string;
  changeSpeed: string;
  speed: string;
  reduceSpeed: string;
  increaseSpeed: string;
  
  // Tabs
  chapters: string;
  backgroundMusic: string;
  bookmarks: string;
  settings: string;
  
  // Chapters
  saveBookmark: string;
  currentPosition: string;
  
  // Music Player
  musicService: string;
  volume: string;
  spotifyUri: string;
  youtubeUrl: string;
  localPlaylist: string;
  
  // Bookmarks
  noBookmarks: string;
  createdAt: string;
  loadBookmark: string;
  deleteBookmark: string;
  bookmarkSaved: string;
  
  // Settings
  configuration: string;
  howToUse: string;
  howToUseSteps: {
    step1: string;
    step2: string;
    step3: string;
  };
  progress: string;
  progressInfo: string;
  completedChapters: string;
  
  // Playlist Manager
  myPlaylists: string;
  createPlaylist: string;
  playlistName: string;
  playlistType: string;
  localFiles: string;
  youtubePlaylist: string;
  create: string;
  cancel: string;
  addTrack: string;
  trackName: string;
  trackUrl: string;
  add: string;
  selectTrack: string;
  playPause: string;
  deletePlaylist: string;
  editPlaylist: string;
  tracks: string;
}

export const translations: Record<'es' | 'en', Translations> = {
  es: {
    // Header
    by: "por",
    
    // Player
    noChapterSelected: "No hay capítulo seleccionado",
    changeSpeed: "Cambiar velocidad",
    speed: "Velocidad",
    reduceSpeed: "Reducir velocidad",
    increaseSpeed: "Aumentar velocidad",
    
    // Tabs
    chapters: "Capítulos",
    backgroundMusic: "Música de Fondo",
    bookmarks: "Marcadores",
    settings: "Configuración",
    
    // Chapters
    saveBookmark: "Guardar Marcador",
    currentPosition: "Posición actual:",
    
    // Music Player
    musicService: "Servicio de música",
    volume: "Volumen",
    spotifyUri: "URI de Spotify",
    youtubeUrl: "URL de YouTube",
    localPlaylist: "Lista local",
    
    // Bookmarks
    noBookmarks: "No hay marcadores guardados",
    createdAt: "Creado el",
    loadBookmark: "Cargar marcador",
    deleteBookmark: "Eliminar marcador",
    bookmarkSaved: "Marcador guardado exitosamente",
    
    // Settings
    configuration: "Configuración",
    howToUse: "Cómo usar:",
    howToUseSteps: {
      step1: "Para Spotify: Copia el URL de la pista y pégalo",
      step2: "Para YouTube: Copia el URL del video/canción y pégalo",
      step3: "Ajusta el volumen de la música independientemente del audiolibro"
    },
    progress: "Progreso:",
    progressInfo: "Tu progreso se guarda automáticamente en el navegador.",
    completedChapters: "Capítulos completados:",
    
    // Playlist Manager
    myPlaylists: "Mis Listas de Reproducción",
    createPlaylist: "Crear Lista de Reproducción",
    playlistName: "Nombre de la lista",
    playlistType: "Tipo de lista",
    localFiles: "Archivos locales",
    youtubePlaylist: "Lista de YouTube",
    create: "Crear",
    cancel: "Cancelar",
    addTrack: "Añadir Pista",
    trackName: "Nombre de la pista",
    trackUrl: "URL de la pista",
    add: "Añadir",
    selectTrack: "Seleccionar pista",
    playPause: "Reproducir/Pausar",
    deletePlaylist: "Eliminar lista",
    editPlaylist: "Editar lista",
    tracks: "pistas"
  },
  
  en: {
    // Header
    by: "by",
    
    // Player
    noChapterSelected: "No chapter selected",
    changeSpeed: "Change speed",
    speed: "Speed",
    reduceSpeed: "Reduce speed",
    increaseSpeed: "Increase speed",
    
    // Tabs
    chapters: "Chapters",
    backgroundMusic: "Background Music",
    bookmarks: "Bookmarks",
    settings: "Settings",
    
    // Chapters
    saveBookmark: "Save Bookmark",
    currentPosition: "Current position:",
    
    // Music Player
    musicService: "Music service",
    volume: "Volume",
    spotifyUri: "Spotify URI",
    youtubeUrl: "YouTube URL",
    localPlaylist: "Local playlist",
    
    // Bookmarks
    noBookmarks: "No saved bookmarks",
    createdAt: "Created on",
    loadBookmark: "Load bookmark",
    deleteBookmark: "Delete bookmark",
    bookmarkSaved: "Bookmark saved successfully",
    
    // Settings
    configuration: "Settings",
    howToUse: "How to use:",
    howToUseSteps: {
      step1: "For Spotify: Copy the track URL and paste it",
      step2: "For YouTube: Copy the video URL and paste it",
      step3: "Adjust music volume independently from the audiobook"
    },
    progress: "Progress:",
    progressInfo: "Your progress is automatically saved in the browser.",
    completedChapters: "Completed chapters:",
    
    // Playlist Manager
    myPlaylists: "My Playlists",
    createPlaylist: "Create Playlist",
    playlistName: "Playlist name",
    playlistType: "Playlist type",
    localFiles: "Local files",
    youtubePlaylist: "YouTube playlist",
    create: "Create",
    cancel: "Cancel",
    addTrack: "Add Track",
    trackName: "Track name",
    trackUrl: "Track URL",
    add: "Add",
    selectTrack: "Select track",
    playPause: "Play/Pause",
    deletePlaylist: "Delete playlist",
    editPlaylist: "Edit playlist",
    tracks: "tracks"
  }
};

export type Language = 'es' | 'en';